// import { Badge } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
// import classNames from 'classnames';

// import { Post, Post1 } from 'components/blog';
// import { post1 } from './data';
// import campaginDetailsView from 'assets/images/hero/New folder/campaginDetailsView.png';
// import BlogImage from 'assets/images/hero/New folder/BlogImage.jpg';

// type BlogPostProps = {
//     Post1: Post1;
// };


// const formatTitleForURL = (title?: string) =>
//     title
//         ? title
//             .toLowerCase()
//             .replace(/[^a-z0-9\s-]/g, '')
//             .replace(/\s+/g, '-')
//             .trim()
//         : '';


// const BlogPost2 = ({ Post1 }: BlogPostProps) => {
//     const blogUrl = Post1.title ? `/blog/${formatTitleForURL(Post1.title)}` : "#";
//     console.log('Post1', Post1);

//     return (
//         <>
//             <div>
//                 <div className='border border-dark  mt-2 mb-2 rounded'>
//                     <img src={Post1.image || BlogImage} alt={Post1.title || "sales blog"} className="img-fluid d-block shadow rounded" style={{ width: "100%", height: "250px", objectFit: "cover" }} />
//                 </div>
//                 <div className="mt-3">
//                     <p>
//                         {new Intl.DateTimeFormat("en-US", {
//                             day: "numeric",
//                             month: "long",
//                             year: "numeric"
//                         }).format(new Date(Post1.createdOn))}
//                     </p>

//                     <Link to="#">
//                         <Badge bg="" className={classNames('badge-soft-orange mb-1')}>
//                             {Post1.tag}
//                         </Badge>
//                     </Link>
//                 </div>

//                 <h4 className="fw-semibold mt-1">

//                     <Link to={blogUrl} state={{ id: Post1.id }} className="">
//                         {Post1.title}
//                     </Link>
//                 </h4>


//                 <p className="text-muted mb-5">
//                     {Post1.description}...  <br />
//                     <Link
//                         to={blogUrl}
//                         state={{ id: Post1.id }}
//                         style={{
//                             backgroundColor: '#5c6f88',
//                             color: '#fff',
//                             padding: '6px 18px',
//                             borderRadius: '6px',
//                             fontWeight: 600,
//                             textDecoration: 'none',
//                             display: 'inline-block',
//                             cursor: 'pointer',
//                         }}
//                         onMouseEnter={(e) => {
//                             (e.currentTarget as HTMLElement).style.backgroundColor = '#4d6078';
//                         }}
//                         onMouseLeave={(e) => {
//                             (e.currentTarget as HTMLElement).style.backgroundColor = '#5c6f88';
//                         }}
//                     >
//                         Read More
//                     </Link>
//                 </p>
//             </div>
//         </>
//     );
// };

// export default BlogPost2;




import { Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { Post, Post1 } from 'components/blog';
import { post1 } from './data';
import campaginDetailsView from 'assets/images/hero/New folder/campaginDetailsView.png';
import BlogImage from 'assets/images/hero/New folder/BlogImage.jpg';
import BlogImage2 from 'assets/images/hero/New folder/BlogImage2.png';

// import { Link } from "react-router-dom";
import { Clock, ArrowRight } from "lucide-react";
type BlogPostProps = {
    Post1: Post1;
};


const formatTitleForURL = (title?: string) =>
    title
        ? title
            .toLowerCase()
            .replace(/[^a-z0-9\s-]/g, '')
            .replace(/\s+/g, '-')
            .trim()
        : '';


const BlogPost2 = ({ Post1 }: BlogPostProps) => {
    const blogUrl = Post1.title ? `/blog/${formatTitleForURL(Post1.title)}` : "#";
    console.log('Post1', Post1);

    const truncateText = (text: string | undefined, maxLength: number) => {
        if (!text) return "";
        return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
    };

    return (
        <>
            {/* <div>
                <div className='border border-dark  mt-2 mb-2 rounded'>
                    <img src={Post1.image || BlogImage} alt={Post1.title || "sales blog"} className="img-fluid d-block shadow rounded" style={{ width: "100%", height: "250px", objectFit: "cover" }} />
                </div>
                <div className="mt-3">
                    <p>
                        {new Intl.DateTimeFormat("en-US", {
                            day: "numeric",
                            month: "long",
                            year: "numeric"
                        }).format(new Date(Post1.createdOn))}
                    </p>

                    <Link to="#">
                        <Badge bg="" className={classNames('badge-soft-orange mb-1')}>
                            {Post1.tag}
                        </Badge>
                    </Link>
                </div>

                <h4 className="fw-semibold mt-1">

                    <Link to={blogUrl} state={{ id: Post1.id }} className="">
                        {Post1.title}
                    </Link>
                </h4>


                <p className="text-muted mb-5">
                    {Post1.description}...  <br />
                    <Link
                        to={blogUrl}
                        state={{ id: Post1.id }}
                        style={{
                            backgroundColor: '#5c6f88',
                            color: '#fff',
                            padding: '6px 18px',
                            borderRadius: '6px',
                            fontWeight: 600,
                            textDecoration: 'none',
                            display: 'inline-block',
                            cursor: 'pointer',
                        }}
                        onMouseEnter={(e) => {
                            (e.currentTarget as HTMLElement).style.backgroundColor = '#4d6078';
                        }}
                        onMouseLeave={(e) => {
                            (e.currentTarget as HTMLElement).style.backgroundColor = '#5c6f88';
                        }}
                    >
                        Read More
                    </Link>
                </p>
            </div> */}

            <article style={{ backgroundColor: 'white' }} className="bg-white rounded rounded-xl overflow-hidden shadow-sm border border-2  border-blck hover:shadow-lg transition-all duration-300">
                {/* Thumbnail */}
                <Link to={`/blog/${Post1.id}`}>
                    <div className="relative w-full overflow-hidden ">
                        <img
                            src={Post1.image || BlogImage2}
                            alt={Post1.title}
                            className="w-full h-auto py-1 px-1 object-contain"
                        />
                    </div>
                </Link>



                {/* Content */}
                <div className="p-3">
                    <div className="flex items-center text-sm text-gray-500 mb-3">
                        <time dateTime={Post1.createdOn}>
                            {new Date(Post1.createdOn).toLocaleDateString("en-US", {
                                month: "long",
                                day: "numeric",
                                year: "numeric",
                            })}
                        </time>
                    </div>

                    <Link to="#">
                        <Badge bg="" style={{ backgroundColor: 'blue' }} className={classNames('badge-soft-blue text-white mb-1 p-2')}>
                            {Post1.tag}
                        </Badge>
                    </Link>


                    {/* Title */}
                    {/* <Link to={`/blog/${Post1.id}`}>
                        <h4 className="text-lg font-semibold mb-3 hover:text-blue-600 transition-colors">
                            {Post1.title}
                        </h4>
                    </Link> */}


                    <h4 className="text-lg font-semibold mb-3 hover:text-blue-600 transition-colors">
                        <Link to={blogUrl} state={{ id: Post1.id }} className="">
                            {Post1.title}
                        </Link>                 </h4>

                    {/* Description */}
                    {/* <p className="text-gray-600 mb-5 line-clamp-3">{Post1.description}</p> */}
                    <p className="text-gray-600 mb-3">
                        {truncateText(Post1.description, 100)}
                    </p>

                    {/* Author + Read More */}
                    <div className="flex items-center justify-end">
                        <Link
                            to={blogUrl}
                            state={{ id: Post1.id }}
                            className="flex items-center text-sm font-medium"
                            style={{ color: "#1e40af" }}
                        >
                            Read More
                            <ArrowRight className="w-4 h-4 ml-1" style={{ color: "#1e40af" }} />
                        </Link>
                    </div>
                </div>
            </article>

        </>
    );
};

export default BlogPost2;

